import { render, staticRenderFns } from "./AuthorizedColumn.vue?vue&type=template&id=450df403&scoped=true"
import script from "./AuthorizedColumn.vue?vue&type=script&lang=js"
export * from "./AuthorizedColumn.vue?vue&type=script&lang=js"
import style0 from "./AuthorizedColumn.vue?vue&type=style&index=0&id=450df403&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450df403",
  null
  
)

export default component.exports